<!--
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
-->
<app-dialog-banner text="Error Detail" [dialogRef]="dialogRef"></app-dialog-banner>
<mat-dialog-content class="detailContent">
    <div class="messageBanner">
        <mat-icon>report</mat-icon>
        <span>{{error.message || 'No message recorded'}}</span>
    </div>

    <div class="fieldGrid">
        <div class="field">
            <span class="label">Date</span>
            <span class="value">{{error.logDate}}</span>
        </div>
        <div class="field">
            <span class="label">Team</span>
            <span class="value mono">{{error.teamId || '—'}}</span>
        </div>
        <div class="field">
            <span class="label">User</span>
            <span class="value">{{error.userName || '—'}} <span class="mono muted">{{error.userId}}</span></span>
        </div>
        <div class="field">
            <span class="label">Related</span>
            <span class="value">{{error.relatedName || '—'}} <span class="mono muted">{{error.relatedId}}</span></span>
        </div>
        <div class="field wide">
            <span class="label">Path</span>
            <span class="value mono">{{error.pathName || '—'}}</span>
        </div>
        <div class="field wide">
            <span class="label">Full Path</span>
            <span class="value mono">{{error.fullPath || '—'}}</span>
        </div>
    </div>

    <div class="stackTraceHeader">
        <mat-icon>terminal</mat-icon>
        <span>Stack Trace</span>
    </div>
    <pre class="stackTrace">{{error.stackTrace}}</pre>
</mat-dialog-content>
